const cn = {
    message: {
        noNet: '網絡錯誤',
        goCopilot: '分析當晚睡眠及建議',
        goCopilotWeek: '分析本週的睡眠',
        goCopilotMonth: '分析本月的睡眠',
        updateAppTips: 'La versión actual no se puede mostrar. Por favor, actualice a la última versión!',
        vip: {
            openVip: "開通會員",
            sleepVip: "睡眠會員",
            notOpened: "未開通",
            expired: "已過期",
            validUntil: "有效期至：",
            unlockAll: "解鎖全部助眠音",
            trendAnalysis: "睡眠趨勢分析",
            reportAnalysis: "專屬月報分析",
            deepAnalysis: "深度睡眠分析",
            monthlyVip: "月度會員",
            quarterlyVip: "季度會員",
            annualVip: "年度會員",
            priceEvery: "{price} {oversea}元/月",
            yuanEveryMonth: "{oversea}元/月",
            yuanEveryQuarter: "{oversea}元/季度",
            yuanEveryYear: "{oversea}元/年",
            open: "開通",
            renew: "立即續費",
            renewal: "續費",
            vipMonthExtention: "",
            vipQuartyExtention: "",
            vipYearExtention: "",
            discountLimited: "限時{discount}折",
            discountDuration: "限時折扣活動持續到{date}",
            vipUseDescription1: '解鎖全部助眠音',
            vipUseDescription2: '就寢、起床時間趨勢',
            vipUseDescription3: '心率、血氧趨勢',
        },
        sleep: {
            regularSleep: "常規睡眠",
            nap: "小睡",
            hour: "小時",
            minute: "分鐘",
            sleepQuality: "睡眠质量",
            sober: "清醒",
            fastEye: "快速動眼",
            lightSleep: "淺眠",
            darkSleep: "深眠",
            sleepStage: "睡眠階段",
            suggestRange: "建議睡眠區間",
            avgSleepHeartRate: "平均睡眠心率",
            timesEveryMin: "次/分鐘",
            unitsleepbreath: "次/分鐘",
            once: "次",
            sleepOxygen: "睡眠血氧飽和度",
            sleepBreath: "睡眠呼吸率",
            highest: "最高",
            lowest: "最低",
            maximum: "最大",
            minimum: "最小",
            normal: "正常",
            average: "平均",
            openMonitoring: "開啟監測次數",
            longerMonitor: "監測天數越長越準確",
            avgStatistics: "平均數據統計",
            sleepDuration: "睡眠時長",
            bedTime: "就寢時間",
            getUpTime: "起床時間",
            maxSleep: "最長睡眠時間",
            minSleep: "最短睡眠時間",
            earliestBedTime: "最早就寢時間",
            latestBedTime: "最晚就寢時間",
            earliestGetUpTime: "最早起床時間",
            latestGetUpTime: "最晚起床時間",
            excellent: "優良",
            good: "良好",
            improvement: "改進",
            importance: "重視",
            sleepEnough: "睡眠充足：{min}-{max}h",
            sleepToLong: "睡眠過長：多於{hour}h",
            sleepDebt: "睡眠不足：少於{hour}h",
            sleepPeriodVary1: "不同年齡的睡眠時段會有差異，您當前填寫的年齡為{age}歲",
            sleepPeriodVary2: "不同年齡的睡眠時段會有差異，您當前填寫的年齡為{month}個月",
            toSet: "去設定",
            openVipToSee: "開通會員繼續查看",
            short_mon: "一",
            short_tue: "二",
            short_wed: "三",
            short_thu: "四",
            short_fri: "五",
            short_sat: "六",
            short_sun: "日",
            mon: "一",
            tue: "二",
            wed: "三",
            thu: "四",
            fri: "五",
            sat: "六",
            sun: "日",
            monday: "週一",
            tuesday: "週二",
            wednesday: "週三",
            thursday: "週四",
            friday: "週五",
            saturday: "週六",
            sunday: "週日",
            day: "日",
            heartRate: "心率",
            bloodOxygen: "血氧飽和度",
            breathRate: "呼吸率",
            noData: "無常規睡眠數據",
            noNapData: "無小睡數據",

            sleepLateTipCommonStart: "您昨晚的入睡時間比平時晚，",
            sleepTipCommonEnd: "保證規律的作息有利於獲得好的睡眠。",
            sleepLate3tip: "本週已累計{day}天了，工作很累也要注意休息，",
            sleepLate2TipStart: "您昨晚的入睡時間比平時晚，",
            sleepLate2Tip: "已經連續2天了，要注意休息，",
            getUpEarlyTip: "您今天的起床時間比平時早，",
            getUpLateTip: "您今天的起床時間比平時晚，",
            sleepEarlyTip: "您昨晚的入睡時間比平時早，",


            demoData: "演示數據",

            sleepCompare: "睡眠數據比對", // todo
            seeMore: "查看更多",
            sleepQualityData: "您的睡眠質量為{value}",
            sleepQualityCompare1: "擊敗了",
            sleepQualityCompare2: "僅高於",
            sleepQualityCompare3: "的用戶",
            sleepQualityBestTip: "堅持良好的睡眠可以保障睡眠健康哦～",
            sleepQualityGoodTip: "睡眠質量有待提升啦！",
            sleepQualityBadTip: "請重視起來，讓自己擁有一個良好的睡眠",
            sleepTimeText: "您的睡眠時長",
            avgCnSleepTimeText: "中國平均睡眠時長",
            avgGlobalSleepTime: "全球平均睡眠時長",
            sleepTimeTip: "每個人都要保證足夠的睡眠時長，這樣可以有效的消除疲勞，對身體健康有一定的好處；但是睡眠時間也不要過長哦。",
            bedTimeText: "您的就寢時間",
            avgCnBedTimeText: "中國平均就寢時間",
            avgGlobalBedTime: "全球平均就寢時間",
            bedTimeTip: "就寢時間看起來很簡單，實際是一個很關鍵的指標；養成良好的就寢規律可以保護大腦，變得更容易入睡，也可以提高睡眠質量。",
            getUpTimeText: "您的起床時間",
            avgCnGetUpTimeText: "中國平均起床時間",
            avgGlobalGetUpTime: "全球平均起床時間",
            getUpTimeTip: "起床時間也是一個不可忽視的指標，保證規律的起床時間可以使自己整天都有一個比較良好精神狀態。",

            sleepStageTitle: "睡眠階段分析",
            avgAwakeSleep: "平均清醒",
            avgFastEyeMove: "平均快速眼動",
            avgShallowSleep: "平均淺睡",
            avgDeepSleep: "平均深睡",
            skinTemperature: "皮膚溫度",
            temperatureLow: "偏低",
            temperatureHigh: "偏高",
            reasonableRange: "合理範圍",

            compare: {
                dataInsights: '數據洞察',
                today: '今天',
                yesterday: '昨天',
                currentWeek: '本週',
                preWeek: '上週',
                currentMonth: '本月',
                preMonth: '上個月',
                daySleepTimeHigher: '今天的睡眠時間比昨天長',
                daySleepTimerLower: '今天的睡眠時間比昨天短',
                daySleepTimerRegular: '近兩天的睡眠時間相當規律',

                dayBedTimeEarly: '今天的就寢時間比昨天早',
                dayBedTimeLater: '今天的就寢時間比昨天晚',
                dayBedTimeRegular: '近兩天的就寢時間比較規律',

                dayGetupTimeEarly: '今天的起床時間比昨天早',
                dayGetupTimeLater: '今天的起床時間比昨天晚',
                dayGetupTimeRegular: '近兩天的起床時間比較規律',
                DayEmptyTip: '昨日沒有睡眠紀錄，堅持佩戴設備睡眠可幫助您了解睡眠數據情況',


                weekSleepTimeHigher: '本週平均睡眠時長比上週長',
                weekSleepTimerLower: '本週平均睡眠時長比上週短',
                weekSleepTimerRegular: '近兩週的平均睡眠時長比較規律',

                weekBedTimeEarly: '本週平均就寢時間比上週早',
                weekBedTimeLater: '本週平均就寢時間比上週晚',
                weekBedTimeRegular: '近兩週的平均就寢時間比較規律',

                weekGetupTimeEarly: '本週平均起床時間比上週早',
                weekGetupTimeLater: '本週平均起床時間比上週晚',
                weekGetupTimeRegular: '近两周的平均起床时间比较规律',
                weekEmptyTip: '上週沒有睡眠記錄，但持續佩戴裝置睡眠可幫助您了解睡眠數據情況',

                monthSleepTimeHigher: '本月的平均睡眠時長比上個月長',
                monthSleepTimerLower: '本月的平均睡眠時長比上個月短',
                monthSleepTimerRegular: '近兩個月的平均睡眠時長比較規律',

                monthBedTimeEarly: '本月平均就寢時間比上月早',
                monthBedTimeLater: '本月平均就寢時間比上月晚',
                monthBedTimeRegular: '近兩個月的平均就寢時間比較規律',

                monthGetupTimeEarly: '本月平均起床時間比上月早',
                monthGetupTimeLater: '本月平均起床時間比上月晚',
                monthGetupTimeRegular: '近兩個月的平均起床時間比較規律',
                monthEmptyTip: '上個月沒有睡眠紀錄。佩戴睡眠監測設備可以幫助您了解睡眠數據情況',

                delete: '刪除',
                deleteTitle: '刪除日報記錄？',
                deleteContent: '刪除日報記錄後，相應的周報和月報數據也會被刪除，確定永久刪除當前日報數據？',
                confirm: '確定',
                cancel: '取消'

            }
        },
        advert: { // todo
            tip: '早鸟特惠',
            ActivityStartTime: '开始时间',
            ActivityEndTime: '结束时间',
            ActivityEnded: '已结束～',
            buy: '立即抢购',
            explainTitle: '活动说明',
            explainDesc1: '1. 早鸟特惠活动持续时间为2022.12.16～2022.12.31',
            explainDesc2: '2. 活动期间内，您可享受最低4.5折购买会员权益',
            explainDesc3: '3. 充值成功后可在“首页-睡眠卡片-开始睡眠-vip”中查看自己会员的有效期',
            explainDescLast: '4. 本活动最终解释权归mobvoi所有',
            viewVipFunctions: '查看会员功能',
            VipFunctionsExplain: "会员功能说明"
        },
        snore: {
            "snoringDetectionReport": "鼾聲檢測報告",
            "snoreRecord": "鼾聲記錄",
            "more": "查看更多",
            "notOpenedTip": "請在睡覺前，在“首頁-睡眠卡片-開始睡眠-立即睡眠”中打開鼾聲監測功能。在睡眠結束後，請記得關閉監測，鼾聲記錄將會被自動生成。",
            "noSnoring": "本次睡眠未打鼾~",
            "snoreData": "鼾聲數據",
            "snoreReport": "鼾聲報告",
            "snoreDuration": "時長",
            "avgSnoreDb": "平均分貝",
            "maxSnoreDb": "最大分貝",
            "minSnoreDb": "最小分貝",
            "snoreDbRatio": "鼾聲分貝佔比",
            "snoreWaveforms": "鼾聲波紋趨勢",
            "snoreFrequency": "鼾聲頻率分布",
            "snoreFrequencyTrend": "打鼾頻率趨勢",
            "low": "低頻率",
            "medium": "中頻率",
            "high": "高頻率",
            "softSnore": "軟腭打鼾",
            "uvulaSnore": "會厭打鼾",
            "tongueSnore": "舌根打鼾",
            "snoreRecordSetting": "設置",
            "storageMethods": "存儲方式",
            "storageDurations": "存儲時間",
            "local": "本地",
            "cloud": "雲端",
            "localStorage": "本地存儲",
            "cloudStorage": "雲端存儲",
            "storageWayTips": "您可以選擇將您的鼾聲數據存儲在本地或雲端；存儲在本地將會占據您的存儲空間；存儲在雲端需要開通睡眠會員權限，最多可以為您保留180天的數據。",
            "storagePeriod": "您可以選擇打鼾數據的存儲時間。為了保護您的數據安全，我們設定了最短1天，最長180天的存儲時長；若您選擇1天，則第二天會將您的打鼾數據清除；開通會員後可享受30天和180天的存儲時長。",
            "storagePeriodWearCopilot": "您可以選擇打鼾數據的存儲時間。",
            "day": "天",
            "days": "天",
            recordSnoreTitle1: '1.記錄鼾聲',
            recordSnoreContent1: '每晚睡前開啟鼾聲檢測功能，起床後記得手動結束睡眠，記錄完整的鼾聲數據。',
            recordSnoreTitle2: '2.在日報中檢視鼾聲記錄',
            recordSnoreContent2: '在日報中可查看三條鼾聲記錄，點擊可播放自己的鼾聲記錄。',
            recordSnoreTitle3: '3.更多的鼾声数据分析',
            recordSnoreContent3: '在每日報告中點擊“查看更多”以查看所有鼾聲記錄並分析分貝、波形、分布、頻率等。',
            "tips": "提示",
            "vipTips": "啟用此功能需要訂閱睡眠會員。現在立即訂閱睡眠會員嗎？",
            "open": "立即開通",
            "noAudioTip": "鼾聲音頻加載中，請稍後再試。",
        },
    },

    "cookie_policy": {
        "title": "Cookie聲明",
        "para": "我們可能會持續由緩存文件、日誌文件、網絡信標、腳本、各種標簽及其它跟蹤技術，收集、使用及儲存您的相關信息。此部分將會對我們如何使用跟蹤技術進行說明。",
        "q_1": {
            "question": "1. 為何我們要使用追蹤技術？",
            "ans_1": "A. 幫助我們更好地瞭解並為您及我們的用戶提供墨百意服務",
            "ans_2": [
                "B. 追蹤技術能使我們瞭解以及為您提供更好的墨百意服務。例如，跟踪服務可以幫助我們收集以下信息：",
                "a) 在墨百意為您提供服務之時，我們須取得您核實的信息；",
                "b) 我們地圖及以定位為基礎的服務，有可能需要你所處位置的信息；",
                "c) 我們的翻譯服務，或會需要你語言選擇的信息；",
                "d) 我們需要我們用戶的其它相關信息，以便提供墨百意服務，以及開發新功能。"
            ]
        },
        "q_2": {
            "question": "2. 何為追蹤技術？",
            "para": "追蹤技術，在墨百意中的運用包括：",
            "ans_1": "A. 緩存文件是一種包含系列字符，當您登錄網站或瀏覽網站其它資訊時，此種文件即會被存儲於你的電腦、移動電話或其它設備上；",
            "ans_2": "B. 網絡信標為電子圖片文件，或其它網絡上已存在之技術及郵件，可用於統計瀏覽人數，記錄你是否有查閱郵件、瀏覽網站或使用臨時文件的時間；",
            "ans_3": "C. 日誌文件中的信息，均為自動獲得。例如包含IP地址，瀏覽器之類型，ISP，瀏覽/退出頁面，操作系統，日期/時間以及單擊流數據之信息；",
            "ans_4": "D. 設置標簽是後臺網絡瀏覽器與網絡服務器之間傳輸http協議的首部信息。其可替代緩存文件以追蹤個人用戶，使我們瞭解及提升墨百意之服務；",
            "ans_5": "E. JavaScript為一種程序設計語言，用於製作更多互動和動態的頁面。JavaScript可設置、閱讀及刪除緩存文件。"
        },
        "q_3": {
            "question": "3. 我們怎樣使用追蹤技術",
            "para": "我們與第三方組成合作夥伴以使用其追蹤技術",
            "ans_1": "A. 我們，我們的子公司和第三方合作夥伴會持續利用追蹤技術以收集和使用某些信息；",
            "ans_2": "B. 我們的分析合作商會協助我們對墨百意有一個總體上的深度認識。例如，收集網頁的使用數據和申請表，收集我們用戶的基本人口資料，分析相關趨勢；",
            "ans_3": "C. 我們的客戶支持服務合作商會協助我們更好地響應您的需求，同時為我們墨百意用戶提供更好的使用體驗；",
            "ans_4": "D. 我們的服務商會協助我們管理及提供墨百意的部分服務功能，如網頁快取、語言翻譯及地圖等服務；",
            "ans_5": "E. 我們可能會從合作商中取得個人和總體用戶的報告，以用到追蹤技術中。"
        },
        "q_4": {
            "question": "4. 我們自己的追蹤技術",
            "ans_1": "A. 另外，我們亦會使用自身擁有的追蹤技術，以令你的服務體驗更加個性化。例如，通過語音對話歷史記錄瞭解您的偏好及準確回答問題；利用旅行及行程管理資訊提供旅行及行程提醒；利用運動及健康資訊給您提供運動及健康建議；通過分析您的網上商城及商鋪之購物信息為您推薦所感興趣之頁面和APP；",
            "ans_2": "B. 記錄您的身份信息。例如：緩存文件和網絡信標，對我們確認您是我們服務的註冊用戶，或記錄您的偏好或之前提供之其它信息，和分析你如何使用我們的服務均有巨大幫助。我們可利用追蹤技術以瞭解用戶對我們的服務的操作，或受歡迎之頁面或鏈接；",
            "ans_3": "C. 我們在為某些目的而使用追蹤技術的同時，也會為我們的合作商提供由追蹤技術收集到整體而非個人的信息，用以分析您和其他用戶對我們服務的使用情況。請知悉。"
        },
        "q_5": {
            "question": "5. 追蹤技術條款",
            "ans_1": "A. 您必須瞭解到第三方的追蹤技術是受到他們隱私政策的限制，而非我們的。我們不會對任何第三方的追蹤技術承擔責任；",
            "ans_2": "B. 我們有可能會將由追蹤技術收集到的信息與我們收集到您的其他信息進行結合。例如，如果您通過第三方在線廣告安裝並註冊墨百意的服務，我們和/或我們的第三方合作夥伴可以利用跟蹤技術告知我們您在哪裡知道墨百意的服務。"
        },
        "q_6": {
            "question": "6. 您如何控制追蹤技術呢？",
            "ans_1": "A. 您可以通過更改瀏覽器設置（如Cookies或網酪信標）或移動設備來禁止或管理某些類別的跟蹤技術。但請註意，如果您禁止使用追蹤技術，我們可能無法向您提供墨百意服務的最佳使用體驗，並且墨百意的部分或全部功能可能無法正常運行；",
            "ans_2": "B. 您可通過對墨百意服務的設置來控制哪些信息我們可通過追蹤技術收集而得。"
        }
    },
    "terms_of_service": {
        "title": "服務條款",
        "para_1": [
            "以下服務條款適用於：墨百意信息科技有限公司及其關聯方 (合稱「墨百意」、「我司」、「我們」或「我司的」)發佈的所有APP；墨百意的網站，包括www.chumenwenwen.com、store.ticwear.com和www.mobvoi.com（包括為無線或平板設備優化的版本）；墨百意公佈或發佈的所有電郵時事簡訊；由墨百意提供、我司運營並提供，或由墨百意出品並維護的，以任何方式訪問和/或使用的其他所有交互特性與通信功能（合稱\"APP\"），以及墨百意通過該APP提供的或有關該APP的所有服務（稱「服務」）。使用我司APP即代表您接受本服務條款所述操作規定。若不同意本服務條款，請勿使用本APP並立即退出。我司保留隨時修改或修正本服務條款的權利。若在發佈本條款變更告示後仍使用我司APP的，即表明您接受此類變更。經我司向您發出具體通知後，對我司使用條款的變更方可適用，且有追溯效力。對於我司的部分服務，您還須簽署訂閱協議。"
        ],
        "para_2": "此為您（「您」或「用戶」）與墨百意簽署的法律協議，規定了您使用本APP時需遵守的主要條款條件。本協議及其所有更新、補充、附加條款，以及墨百意的所有規則與政策，共同構成您與墨百意間簽署的本「協議」。訪問本APP即表明您接受本協議的法律約束。若您不同意本服務條款及其使用條件，請勿使用本APP並將其卸載",
        "terms_1": [
            "1. APP 與網站的訪問許可。",
            "墨百意授予您訪問並使用本APP或其內容的有限、可撤銷、非排他性、不可轉讓的許可。該許可不包括：對本APP或其內容的轉售或商業性使用；對產品列表、描述或價格的收集或使用；對本APP或其內容的衍生使用；為其他商家的利益而下載或拷貝賬戶信息；或對數據挖掘技術、機器人等類似數據收集與提取工具的使用。未經墨百意的明確書面同意，不得複製、出售、轉售、訪問本APP和/或其中任何部分，或將其用於任何商業用途。未經我司明確書面同意，您不得通過我司名稱或商標來使用任何元標籤或其他「隱藏文本」。此外，您同意不得：(i)採取任何措施對我司的基礎設施施加（按我司自行判斷可能施加）不合理或過大的載荷；(ii)干擾或企圖干擾本APP或為其實施之活動的正常運行；或(iii)規避我司用於防止或限制訪問本APP所採取的措施。未經授權而使用本APP的，將自動終止我司向您授予的權限和/或許可。"
        ],
        "terms_2": [
            "2. 版權與所有權",
            "本APP上特有或展示的所有內容，包括但不限於文本、圖形、照片、圖像、動圖、聲音和插圖（稱「內容」），均歸墨百意、其許可方、供應商、代理和/或其內容提供商所有。本APP的所有元素，包括但不限於總體設計與內容，均受商業外觀、版權、精神權利、商標和其他與知識產權相關的法律的保護。本APP只能用於其預期使用目的。未經版權法的允許，您不得修改任何材料，或拷貝、發佈、傳播、展示、運行、複製、公佈、授予、本APP所含任何信息或作品，或借此創造衍生品、或將其轉讓或出售。未經版權法的授權，您必須先取得許可，方可重復使用本APP上提供的有版權材料。您應遵守有關您使用本APP的所有適用國內與國際法律、章程、條例和規定。除非另有明確約定，本APP及其內容和所有相關權利均屬於墨百意或其許可方的專屬財產。您不得移除本APP所含材料的任何版權、商標或其他所有權通知。"
        ],
        "terms_3": [
            "3. 商標 / 否認聲明。",
            "本文件所含墨百意的所有商標、服務標誌與商號（包括但不限於：墨百意的名稱、墨百意的企業徽號、本APP名稱、本APP的設計、以及任何商標）（合稱「標誌」）均為墨百意或其關聯方、合作夥伴、供應商或許可方的商標或註冊商標。未經墨百意的事先書面同意，您不得以任何方式使用、拷貝、複製、再公佈、上傳、張貼、傳播、發佈或修改墨百意的商標，包括有關本APP上材料發佈的廣告或宣傳。未經事先書面同意，您不得在任何(i)書面或口頭廣告或展示，或(ii)手冊、時事通訊、書籍或其他任何性質的書面材料中使用墨百意的名稱，或（按墨百意的判斷）暗示墨百意認可任何事項的語言、圖片或符號。"
        ],
        "terms_4": [
            "4. 賬戶註冊與安全。",
            "您要瞭解，您可能需要創建賬號來訪問本APP的全部內容。為使用本APP的部分限制內容，您需要：(a)按本APP的註冊或訂閱頁面提示，提供有關您自己以及您的公司的真實、準確、最新並完整的信息（該信息稱為「註冊數據」），以及(b)維護並及時更新該註冊數據，確保其真實、準確、最新且完整。如您提供的任何信息不實、不準確、不是最新或不完整，或墨百意有合理理由懷疑您提供的任何信息不實、不準確、不是最新或不完整，則墨百意有權中止或終止您的賬號並拒絕您目前或未來使用本APP（或其任何部分）。您對您的密碼和賬戶的安全與保密性全權負責。此外，您對您的賬戶下實施的所有活動全權負責。您不得將您的賬戶信息或用戶名和密碼分享給任何第三方，或允許任何第三方使用您的賬戶信息登陸本APP。您同意，如有人未經授權使用您的賬戶，或發現其他安全問題，必須立即通知我司。您有責任採取預防措施，並提供最符合您的狀況和本APP預期使用的安全措施。在某些情況（如在響應法律責任、法律程序、法令、傳票或權證，或為保護我司權利、客戶或業務時）下，我司有權為用戶提供賬單、賬戶、內容或使用記錄和相關信息。請注意，能提供您的個人身份信息的人也能訪問您的賬戶，因此，請採取合理措施保護該信息。"
        ],
        "terms_5": [
            "5. 應請求的政策提交。",
            "若墨百意明確邀請或要求提交資料或進行評論，墨百意鼓勵您向墨百意提交（如對博客帖子添加評論、參加社區、提供小貼士等）為本APP創建的內容（稱「",
            "用戶提交物",
            "」）。用戶提交物歸屬個人用戶的知識產權。在本APP上發佈內容，即代表您明確授予墨百意在全球範圍內，使用任何媒介或技術並以目前已知或未來出現的任何方式（包括促銷、廣告、營銷、推銷、宣傳和對前述的配套使用），使用、複製、修改、改編、公佈、翻譯、發佈、傳播、運行並展示全部或部分該內容以及您的用戶提交物中所含的您的姓名（名稱）、聲音和/或肖像，並借此創造衍生品的非排他性、永久、不可撤回、無版權、全球範圍內已全額付訖、可完全分許可的權利，包括在宇宙範圍內授予該權利分許可的永久自由權。該等用戶提交物視為非機密信息，墨百意沒有義務對用戶提交物所含任何形式的信息保密。"
        ],
        "terms_6": [
            "6. 不當的用戶提交物。",
            "墨百意不鼓勵，亦不尋求可導致如下結果的用戶提交物：(i)有對您、他人或動物造成傷害、損失、身體或精神傷害、情緒低落、死亡、殘疾、毀容或身體或精神疾病的風險；(ii)有造成其他人身或財產損失或損害的風險；或(iii)構成犯罪或侵權。您同意，您過去和未來在提交資料時從未或不得從事前述任何活動。在不限制前述規定的前提下，您同意，在提交資料時，您不得導致他人情緒低落，或（公開或私下）羞辱他人、攻擊或威脅他人，或擅入私有財產，冒充他人或偽造您的從屬關係、權利或授權，亦不得從事可能導致傷害、死亡、財產損害和/或任何責任的活動。墨百意將拒收其按自行判斷認為已發生前述活動的任何提交物。若用戶告知其提交物違反本使用條款，則墨百意有權按其自行判斷確定是否確有違反，並隨時將該提交物從站點移除，無需發出任何通知。"
        ],
        "terms_7": [
            "7. 不當材料。",
            "您不得使用本APP或服務張貼或發送任何違法、侵權、威脅性、中傷、誹謗、淫穢、色情或褻瀆性材料，或侵佔或濫用第三方知識產權，或可能構成或加劇犯罪行為或引發民事責任或違反法律的任何材料。您進一步瞭解並同意，本協議明確禁止向服務的任何用戶未經請求發送廣告或「垃圾郵件」。如我司經自行判斷認為您已違反或可能違反前述禁令，或有關本協議的任何適用規則或政策，除尋求法律或衡平法規定的救濟外，我司還可採取我司認為對糾正或預防該違反行為而必要的措施，包括但不限於禁止您參與我司服務，和/或無需通知即可隨時將服務中的相關材料立即移除。我司將充分配合執法機構或法院命令或傳票，按其要求或指示披露發佈該材料的人員的身份信息。"
        ],
        "terms_8": [
            "8. 用戶已發表內容。",
            "用戶已發表內容和用戶提交物均不代表墨百意或有關墨百意的任何個人的觀點，我司亦不對該內容進行管控。在任何情況下，您不得直接或間接聲明或暗示墨百意支持用戶已發表內容。墨百意不保證我司APP上用戶已發表內容，或通過我司服務發佈的用戶提交物的準確性或可信性，因瀏覽任何用戶已發表內容或用戶提交物而採取任何行動的，墨百意不對該行動承擔任何責任。在使用本APP和服務時，您可能會接觸帶有攻擊性、令人反感、有害、不準確或欺騙性內容。還可能有應對未成年人、欺詐人員、國際貿易問題和外籍人士的風險。使用我司APP和服務即表明您承擔所有有關風險。"
        ],
        "terms_9": [
            "9. 競賽、抽獎和遊戲。",
            "墨百意可不時提供競賽、抽獎和遊戲。如需參與該競賽、抽獎和遊戲，還需遵守其他條款條件。"
        ],
        "terms_10": [
            "10. 廣告權。",
            "墨百意保留出售、許可您的創意提交物的權利，與/或展示有關該提交物的廣告、歸屬、鏈接的權利，並保留有關該提交物的促銷與/或分銷權，且墨百意及其許可方或關聯方有權獲取銷售或許可該廣告、歸屬、鏈接，或促銷或分銷權產生的所有收益。墨百意不因本額外條款而有義務（或視為有義務）出售、許可，或許諾出售或許可任何廣告、促銷或分銷權。"
        ],
        "terms_11": [
            "11. 第三方鏈接。",
            "本APP可能不時包含連接至不歸墨百意或其關聯方擁有、運營或控制的網站的鏈接。所有該等鏈接均為方便目的而向您提供，如您使用該鏈接，您將離開本APP。我司和我司有關關聯方均不對其他網站所含或可訪問的內容、材料或其他信息負責。我司和我司有關關聯方均未對其他網站、其他網站所含或可訪問的內容、材料或其他信息，或您使用其他網站可能取得的結果提供支持、擔保，亦未對此作出任何聲明或保證。如您決定訪問連接至本APP的其他網站，您將自行承擔因此帶來的所有風險。"
        ],
        "terms_12": [
            "12. 交易合作夥伴。",
            "在某些情況下，我司會與其他公司合作，在我司APP上共同推廣他們的服務。在此情況下，您便直接與其他方展開交易。該交易合作夥伴的品牌會清晰標記在有關頁面上。在使用這些合作夥伴的服務時，您將受該方服務條款的約束，我司建議您仔細閱讀他們的服務條款。"
        ],
        "terms_13": [
            "13. 訂購資格。",
            "您只能購買本APP上包含，且交付至墨百意指定區域（包括香港）內地址的產品，您只能為自身或產品預期接收者的個人用途而購買產品。墨百意可拒絕其有合理理由相信將通過未經墨百意批准的分銷渠道進行銷售的訂單。墨百意不承諾本APP上所含產品和服務適合於或可用於指定區域以外的地點，禁止從其內容為違法或非法的區域訪問本APP。如您從指定區域以外地點訪問本APP，您將自行承擔因此引發的風險。您在取得、使用和出售從本APP所購物品時，有責任查實並遵守所有適用的當地與國際法律（包括最低年齡要求）。"
        ],
        "terms_14": [
            "14. 產品、內容與規格。",
            "可供購買的產品和服務詳細信息詳見本APP。本APP上描述或描畫的所有特性、內容、規格、產品、產品與服務的價格無需通知即可隨時變更。某些重量、測量值與類似描述均為大約值，僅為方便目的而提供，包裝可能與顯示的有所不同。我司會做出合理努力準確顯示我司產品的屬性，包括適用顏色；但是，您看到的實際顏色取決於您的電腦系統，我司不能保證您的電腦能準確顯示該顏色。本APP在特定時間包含任何產品或服務的，不得暗示或保證隨時會包含這些產品或服務。某些產品或服務可能偶爾會由於個別原因而出現生產或配送上的延遲。在此情況下，我司將做出合理努力通知您該延遲，並向您更新修訂版交付時間表。下單即代表您聲明只能依法使用已訂購產品。"
        ],
        "terms_15": [
            "15. 貨運限制。",
            "下單後，只要購買者指定的地址符合本APP所含貨運限制，則該訂單將運送至該貨運地址。在本APP上的所有購買行為均按照裝運合同進行，因此，在本APP所購物品交付至承運人之時，該物品的損失風險與權利將轉移給您。若貨物出現損失和/或丟失，您應向承運人提出索賠。"
        ],
        "terms_16": [
            "16. 信息的準確性。",
            "我司會努力確保本APP上的信息保持在完整、準確且最新的狀態。儘管做出以上努力，本APP可能偶爾仍有不準確、不完整或過時的信息。我司不對本APP上信息的完整性、準確性或時效性作出任何聲明，例如，本APP上所含產品可能缺貨，其屬性可能與所列屬性有所不同，或其實際價格可能與本APP所列價格不同。此外，我司可在不作通知的情況下，變更價格與供貨情況。儘管我司會通過郵件確認訂單，但收到郵件訂單確認函並不構成我司接受這一訂單，或我司確認可出售某產品或服務。我司有權在不提前通知的情況下限制任何產品或服務的訂單數量，並/或拒絕向任何客戶提供服務。在接受並/或發運某訂單之前，我司還可要求覈實信息。"
        ],
        "terms_17": [
            "17. 費用。",
            " 對於在本APP或通過本APP出售的任何事件、產品和服務的所有費用或定金，墨百意或其供應商或代理將向您的銀行卡或墨百意提供的其他付款方式開具賬單。提供銀行卡信息、賬戶號碼或便於我司或我司供應商進行扣款的其他必要信息時，您向我司聲明，您為該銀行卡，或用於支付產品和服務費用的其他付款賬戶的經授權用戶。為收取應付結餘必須提起法律訴訟的，您同意為墨百意或其供應商或代理報銷為追償應付金額而承擔的所有費用，包括律師費和其他法律費用。您負責購買使用本APP所需的所有網絡接入服務和電信服務，並支付有相關費用。您瞭解，我司將為付款和定金、損失賠償和其他責任目的而持有並儲存該銀行卡或付款信息。"
        ],
        "terms_18": [
            "18. 訂閱服務的資格。",
            "您可在全球任何地點定閱於本APP上提供的服務。但是，墨百意不承諾本APP上所含服務適合於或提供給墨百意為本APP指定的區域以外的地點，禁止從其內容為違法或非法的區域訪問本APP。如您從指定區域以外的地點訪問本APP，您將自行承擔因此引發的風險。您有責任查實並遵守有關您通過本APP所訂購服務的所有適用的當地與國際法律（包括最低年齡要求）。"
        ],
        "terms_19": [
            "19. 對撤除內容的權利。",
            "除非我司隱私政策另有規定，我司不會對用戶郵件的內容進行監控、編輯或披露，但為正常維護本APP及其系統而必須的，或法律有作此規定，或經善意相信對於以下有必要做出該行動的除外：(1)遵守該法律或墨百意或本APP上提供的法律程序；(2)保護並捍衛墨百意、本APP或本APP用戶的權利或財產；或(3)在緊急情況下保護我司客人、本APP或公眾的個人安全。用戶應為其通信內容全權負責，墨百意無義務對該內容進行預篩。但是，我司有權經自行決定後，在不發出通知的前提下隨時編輯、拒絕公佈或移除提交至本APP或公佈在本APP上的任何材料。在不限制前述規定的情況下，我司有權移除我司發現違反本文件規定或引起異議的任何材料，此外，還有權拒絕違反本服務條款的任何用戶訪問本APP。"
        ],
        "terms_20": [
            "20. 終止。",
            "您或我司均可因任何原因或無理由地隨時中止或終止您在本APP上的賬戶或使用。您對終止前通過您的賬戶下的訂單或產生的費用承擔個人責任。我司還可在以下情況下阻止您訪問我司APP：(a)您違反本服務條款；(b)我司無法對您向我司提供的信息予以覈實或鑒定；或(c)我司認為您的行動會對您自己、我司用戶或我司造成經濟損失或法律責任。"
        ],
        "terms_21": [
            "21. 聲明與保證。",
            "您聲明您已年滿18週歲，擁有前述本協議的權利和授權，具有滿足本協議條款、條件與義務的充分能力，且您使用本APP時會遵守所有適用法律。您已閱讀、瞭解、同意並將遵守本服務條款。而且，您應對自己的用戶提交物以及發佈或公佈該提交物的後果全權負責。對於用戶提交物，您確認、聲明並保證如下：(i)您已取得授予本協議項下許可的所有同意，擁有所有必要版權、專利、商標、商業機密和其他專有權利、或授予該許可的必要許可；(ii)如必要，您已取得用戶提交物中可識別自然人允許按本APP和本協議規定方式使用其姓名或肖像的書面同意，且該自然人已免除您使用其姓名或肖像可能引發的任何責任；(iii)您已閱讀、瞭解、同意並將遵守本協議條款；(iv)您目前或過去並非墨百意的代理，也並非墨百意或有關用戶提交物的其他方的代表；(v)用戶提交物以及墨百意按本協議和墨百意APP的規定對該提交物的使用不會侵犯任何第三方權利，包括但不限於任何知識產權、隱私權和公開權；(vi)您過去和未來均未或不會參與有關您創建用戶提交物、您出現在該提交物中或對該提交物的貢獻的以下任何活動：對任何人或動物施加傷害、羞辱任何人(公共或私下)、對任何人施加精神折磨、攻擊或毆打任何人、擅自損毀任何財產、擅用任何財產、或可能引發民事和/或刑事責任的任何其他作為或不作為；(vii)用戶提交物不會包含：(a)可能傷害墨百意或第三方的重大不實信息或虛假陳述；(b)非法、淫穢、中傷性、誹謗性、威脅性、色情、騷擾性內容，或加劇犯罪行為或引發民事責任或違反法律的內容；(c)商業廣告或誘導；或(d)冒充無法輕易分辨的第三方。"
        ],
        "terms_22": [
            "22. 免責聲明。",
            "您使用本APP時需自行承擔風險。在本APP上或通過本APP提供的信息、材料和服務均「按原樣」提供，不作任何類型的保證，包括關於適銷性、適合特定用途、安全性或不侵犯知識產權的保證。墨百意或其任何關聯方均不對在本APP上或通過本APP提供的信息、材料或服務的準確性或完整性提供保證。在本APP上或通過本APP提供的信息、材料和服務可能已過時，墨百意或其任何關聯方均不保證更新該信息、材料或服務，亦不承擔相應職責。前述除外條款或暗示保證對法律禁止的範圍並不適用，該等禁止規定請參照您所在地的法律。您從墨百意或通過本APP取得的所有口頭或書面建議或信息，均不會產生本文件明確規定以外的其他保證。"
        ],
        "terms_23": [
            "23. 責任限制。",
            " 如在訪問、使用或瀏覽本APP和/或服務，或從本APP下載任何信息或材料時，您的電腦、通信設備或其他財產受到損害，或被病毒傳染的，墨百意概不負責。在任何情況下，對於因使用、無法使用本APP，或使用本APP的結果，或本APP任何或所有部分所含材料、信息或服務而導致您或其他任何人遭受間接、特殊、懲罰性、附帶或後果性損害(包括但不限於利潤損失、數據丟失或業務中斷所產生的後果)，不論是依據保證、合同、侵權或任何其他法理，也不論是否已事先獲知發生此類損害的可能性，墨百意或其任何高管、董事、僱員、股東、關聯方、代理、繼承人或受讓人，或創建、製作或傳播本APP所涉任何當事方概不承擔任何責任。前述責任限制對法律禁止的範圍並不適用，該等禁止規定請參照您所在地的法律。",
            "若本APP和/或服務或本APP任何或所有部分所含材料、信息或服務出現任何問題，您同意終止使用本APP為您的唯一補救措施。任何情況下，對於您根據合同、侵權（包括但不限於疏忽所致）等所遭受的所有損害、損失和訴由，本公司所承擔的全部責任均不超過：(a)二十五美元(US $25.00)或等價的本國貨幣，或(b)您在本APP上已購買或訂閱的服務的價值（兩者中較高者）。"
        ],
        "terms_24": [
            "24. 賠償。",
            "您同意，如因以下產生任何責任，成本和費用的，包括合理產生的律師費，您應捍衛墨百意及其任何關聯方或個人的利益，為其提供賠償並保護其不受傷害：(i)您或經您授權的用戶使用本APP或互聯網或在本APP上發佈或傳播消息或信息；(ii)您違反本協議條款，包括但不限於違反上述任何聲明和保證；(iii)您違反任何第三方權利，包括但不限於任何隱私權、公開權或知識產權；(iv)您違反中華人民共和國或其他管轄區內的任何適用法律、規則或規定；(v)由於您向墨百意提供的任何用戶提交物引發的申索或損害；或(vi)其他方使用您獨一無二的用戶名、密碼或其他驗證碼訪問並使用本APP。"
        ],
        "terms_25": [
            "25. 豁免。",
            "若您與本APP的一位或多位其他用戶發生糾紛，應當豁免墨百意（以及我司高管、董事、代理、子公司、合資企業和僱員）對因該糾紛引發或在任何方面有關該糾紛的任何類型和性質的已知和未知、疑似和確實、已披露和未披露的（實際產生和後果性）申索、要求和損害的責任。"
        ],
        "terms_26": [
            "26. 不可抗力。",
            "由於超過其合理控制範圍的行動或事件導致損害，或未能履約或延遲履約的，墨百意和您均不承擔責任，該行動或事件包括但不限於火災、閃電、爆炸、功率突增或斷電、水災、天災、戰爭、革命、民事騷亂、民事或軍事當局或公敵的行為；任何政府或法律機構或任何此類政府或法律機構的代表制定的法律、秩序、規章、條例或要求；或勞工騷亂，包括不限制罷工、怠工、糾察或抵制；無法獲取原材料、運輸設施、燃料或能源短缺，或其他公共承運人的作為或不作為。"
        ],
        "terms_27": [
            "27. 隱私。",
            "包括對個人身份信息的數據收集與使用在內的數據收集與使用，均受適用於有關APP或服務指定區域的有關墨百意隱私政策的管轄，該隱私政策涵蓋在本協議中，並構成本協議一部分。"
        ],
        "terms_28": [
            "28. 綜述。",
            "有關本APP及其所含材料的申索，以及對本APP及其所含材料的使用均受中華人民共和國法律的管轄。在依據或有關本服務條款的司法和行政程序中可接受本服務條款的打印版，但應保持在與最初以打印版生成並維護的其他商業文件和記錄同樣的範圍內，且應受制於該等文件和記錄的同樣條件。",
            "因本服務條款引發或與其有關的所有糾紛應受北京市海淀區人民法院的專屬管轄，由該法院受理訴訟。",
            "我司不保證可連續、不受干擾或安全訪問本APP，且本APP的運營可能受到超出我司控制的眾多因素干擾。",
            "若本服務條款中任何規定經發現無效或不可執行，則移除該規定，剩餘規定仍可執行。",
            "您同意，墨百意可經自行決定自動轉讓本服務條款及其涵蓋的所有協議。",
            "本協議所用標題僅為方便目的而設，決不對該節範圍或程度進行定義、限制、解釋或描述。",
            "我司未就您或他人的違約行為採取行動，並不表明我們放棄對後繼或類似違約行為採取行動的權利。",
            "本服務條款構成雙方間有關本協議主題的完整諒解與協議。各節若上下文有所規定的，在本協議終止或屆滿後仍然有效。"
        ],
        "terms_29": [
            "29. 其他幫助。",
            "若您不理解前述任何服務條款，或您有疑問或意見，請聯繫我司客戶服務部，發送郵件到{supportEmail}。"
        ],
        "terms_30": [
            "30. 版權聲明。",
            "所有設計、圖形、文本選擇、安排和所有軟件的版權所有© 2018 墨百意信息科技有限公司及其關聯方或許可方。保留所有權利。"
        ],
        "terms_31": [
            "31. 在線交易。",
            " 對於在[www.mobvoi.com]上在線銷售的產品和服務，此類在線交易所基於的購買協議的當事方為[HK SMARTMV LIMITED]，並下達了購買訂單的用戶。 這些服務條款不適用於此類在線交易，另外的服務條款（在線交易）將適用。"
        ]
    },
    "privacy_policy": {
        "title": "《隱私政策》",
        "update_time": "最後更新時間：2020年5月26日（本隱私政策將於2020年5月26日生效）",
        "para_1": "感謝您使用出門問問!",
        "para_2": [
            "您的個人資訊對我們而言至關重要，我們也會尊重您的隱私權。本隱私政策解釋了我們的作用，我們如何收集您的個人資訊，如何分享和使用您的個人資訊，以及您如何行使您的隱私權。本隱私政策適用於我們通過出門問問應用程式、智慧手錶Ticwatch系列設備、智慧耳機TicPods系列設備，以及由出門問問製造的Tichome系列智慧揚聲器（統稱為「出門問問服務」）來收集、使用、處理和存儲您的個人資訊。",
            "",
            "",
            "",
            ""
        ],
        "para_3": [
            "如果您的出門問問服務以英語來提供的，那麼目前的操作系統是由Google谷歌的Wear OS（前稱Android Wear）提供支持。",
            "",
            "出門問問不擁有或不受控於Google谷歌的Wear OS系統，當您與他們互動時，您可能會直接向Google谷歌和其選擇的其他第三方服務，提供有關Wear OS系統的資訊。這些第三方服務將對收集、使用和披露資訊遵循自己的規則。我們建議您查閱他們的隱私政策。"
        ],
        "para_4": [
            "在本政策中，「出門問問」、「我」、「我們」或「我們的」是根據本隱私政策負責您的資訊的台灣出門問問股份有限公司（「數據控制人」）。",
            "",
            ""
        ],
        "para_5": "如果您對於我們使用您的個人資訊有任何疑問或疑慮，請使用本隱私政策底部所提供的聯絡方式與我們取得聯繫。",
        "quick_link": "链接",
        "para_6": "我們建議您完整地閱讀本隱私政策，以確保您完全了解情況。但是，如果您只想訪問本隱私政策的特定部分，則可以單擊下面的相關链接跳轉到該部分。",
        "terms_1": {
            "q": "1. 出門問問简介",
            "para": [
                "台灣出門問問股份有限公司及其所有關聯公司是一家人工智慧公司，總部設在中國北京，但集團公司遍佈全球。我們基於核心語音技術提供服務，使出門問問和我們的授權合作夥伴能夠通過人機交互技術為您提供個性化的生活助理服務。 ",
                "",
                "",
                "有關出門問問的更多資訊，請訪問我們官方網頁中「關於我們」的部分，網址為",
                "https://www.mobvoi.com/tw/pages/about-us。"
            ]
        },
        "terms_2": {
            "q": "2. 處理個人資訊的法律依據",
            "para": [
                "如果您是歐洲經濟區的訪客，我們所收集和使用上述個人資訊的法律依據，將取決於相關的個人資訊以及我們收集的具體情況。",
                "但是，通常僅在如下情況下，我們才會收集您的個人資訊（i）與您簽訂合同，（ii）符合我們的合法權益而不會被您的權利所覆蓋，或者（iii）徵得您的同意。在某些情況下，我們可能還有法律義務向您收集個人資訊，或者可能需要這些個人資訊來保護您的重要權益或其他人的權益。",
                "如果我們要求您提供個人資訊以遵守法律要求，或履行與您之間的合同，我們將在相關時間明確說明您是否必須提供您的個人資訊（並告知不提供個人資訊可能產生的後果）。",
                "如果我們為了我們的合法權益（或任何第三方的權益）收集並使用您的個人資訊，通常是用來運營我們的平臺，並在必要時與您溝通，以便為您提供我們的服務，追求我們的合法商業權益；比如回復您的疑問、改進我們的平臺、進行營銷或檢測或阻止非法活動。我們可能有其他合法權益，如果合適，我們會在相關時間向您告知這些合法權益。",
                "如果您對我們收集使用您的個人資訊的法律依據有任何疑問或需要進一步了解更多的資訊，請使用「聯繫方式」下提供的聯絡方式與我們取得聯繫。",
                "",
                ""
            ]
        },
        "terms_3": {
            "q": "3. 我們如何收集您的個人資訊",
            "para": "當您使用出門問問的服務時，我們會要求收集下列資訊。",
            "title_3_1": "3.1  您自願提供的資訊",
            "content_3_1": [
                "為使用出門問問服務，我們可能會要求您自願提供個人資訊。在我們要求您提供個人資訊時，我們會向您說明您需提供的個人資訊以及需要提供的原因。",
                "使用出門問問服務所需的資訊",
                "這些資訊的提供為實現出門問問核心業務功能的必備資訊、或使用其中某類功能的必備資訊。沒有它，我們可能無法為您提供您要求的所有服務。"
            ],
            "ul_1_1": [
                "帳戶資訊。",
                "當您開通帳戶時，我們需了解如下資訊，例如：姓名、電話號碼和/或電子郵件地址。"
            ],
            "para_3_1": [
                "您選擇與我們分享的個人資訊",
                "您可以選擇向我們提供其他個人資訊，以便在使用出門問問服務時獲得更好的用戶體驗。我們會根據您的同意處理該類資訊。",
                "我們必須提醒您，當您使用智慧手錶TicWatch S＆E、Pro系列時，此類資訊將由Google谷歌提供給Wear OS系統，當Google谷歌和其他Google谷歌應用程式的Wear OS系統需要您的個人資訊時，您將及時獲取相關通知。"
            ],
            "ul_1_2": {
                "li_1": [
                    "其他個人資料資訊。",
                    "您可以選擇在出門問問的個人資料檔案中提供其他資訊（例如性別、照片、暱稱、出生日期、常用地址和郵寄地址）。"
                ],
                "li_2": [
                    "您的生理資訊。",
                    " 當您使用健身應用程式、健康應用程式、心率應用程式、步驟排名應用程序和一些錶盤，您可以選擇提供有關生理特徵、運動和健康的資訊，例如您的身高、體重、年齡、步數、消耗的卡路里、運動模式（例如：跑步還是步行）和具體步行距離。"
                ],
                "li_3": [
                    "有關敏感的個人資訊的提示。",
                    " 您提供的有些類別的個人資訊可能屬於「敏感」的個人資訊，例如您的個人健康資訊；相比其他類別的個人資訊，這些資訊受到更加嚴格的監管。在向出門問問提供任何屬於敏感資訊的個人資訊前，請清楚地考慮是否恰當。",
                    "您同意您的敏感個人資訊可以按本《隱私政策》所述的目的和方式來處理。當然，您有權管理該等資訊，詳情請參閱",
                    "第7節您管理個人資訊的權利。"
                ],
                "li_4": [
                    "資訊分享",
                    " 是指您在出門問問服務上自願共享的資訊或與您有關的資訊。共享資訊可包括您在出門問問帳戶上發布的資訊（包括您的公開個人資訊、您的出門問問帳戶名稱、出門問問帳戶用戶的照片、藍牙、征得您同意後從您的設備中的照片及/或無線收音機感應器所獲取的影片和錄製音頻）。共享資訊亦包括使用出門問問服務的其他用戶分享與您的相關資訊（包括位置數據和日誌資訊）。"
                ]
            },
            "title_3_2": "3.2 我們自動從您使用出門問問服務中收集的資訊",
            "content_3_2": [
                "當您使用出門問問服務時，我們會自動從您的設備收集以下資訊。在某些國家，包括歐洲經濟區的國家，根據適用的數據保護法，此資訊可能會被視為個人資訊。",
                "具體而言，我們自動收集的資訊可能包括您的互聯網服務的網路協議地址、設備類型、唯一設備標識號、瀏覽器類型、大致的地理位置（例如所在國家或城市）和其他技術資訊。我們還可能收集有關您的設備與我們網頁的互動方式的資訊，包括所訪問的頁面和點擊的連結。",
                "收集這些類型的資訊使我們能夠更好地了解用戶。通過這些資訊，我們分析您的偏好、習慣和位置，以便於為您提供更多更精準的定制服務。（例如，準確記錄您的移動軌跡並提供更符合您需求的廣告和促銷資訊）。",
                "這些資訊對於充分履行我們的合同義務是必要的，使我們能夠在履行法律義務的前提下，有能力地提供和改進出門問問服務的功能。"
            ],
            "ul_2": {
                "li_1": [
                    "位置資訊。",
                    " 您使用出門問問產品時所用設備的位置，例如您的移動設備所用的全球衛星導航系統、無線網路、指南針、加速度計或移動設備使用的其他感應器；您用於訪問出門問問服務時，所用的設備或互聯網服務的網路協議地址文檔。"
                ],
                "li_2": [
                    "日誌資訊。",
                    "指您在使用出門問問服務時，我們會自動收集此您的日誌資訊，無論是通過使用Cookie、網路信標、日誌文檔、編程腳本還是電子標籤。欲知更多詳情，請點擊",
                    "「我們如何使用Cookie和其他追蹤技術」",
                    "。"
                ],
                "li_3": [
                    "技術資訊。",
                    " 例如我們會自動收集有關您的移動運營商、網路瀏覽器或您用以登入出門問問的其他程式所提供的設定資訊、互聯網服務的網路協議地址以及您設備的版本和標識號碼（例如IMEI號和Android ID）有關的資訊；"
                ],
                "li_4": [
                    "您通過出門問問所進行的通訊資訊。",
                    " 例如，用於計算我們的每日活躍用戶的通信時間、數據以及持續時間。"
                ]
            },
            "title_3_3": "3.3 我們從第三方獲得的資訊",
            "content_3_3": [
                "我們可能會不時地從第三方來源（包括Google谷歌等）收集到有關您的個人資訊，但僅在於：我們檢查過這些第三方獲得您的同意或在法律允許的情況下，向我們披露您的個人資訊的情況。",
                "我們從第三方收集的資訊類型包括相關的帳戶資訊，我們使用從這些第三方收到的資訊來創建/註冊出門問問的帳戶，並維護和提高我們所持有的關於您的記錄的準確性。",
                "這些第三方將對收集、使用和披露您的資訊有自己的規則。我們建議您查看他們的隱私政策。"
            ],
            "title_3_4": "3.4 基本模式測量的數據",
            "content_3_4": "當您在智慧手錶TicWatch上使用基本模式時，將通過感應器測量心率和步數。 您可以在基本模式中查看心率和步驟的數據值，但我們不會在應用程式中記錄，也不會將這些資訊同步到服務器上。"
        },
        "terms_4": {
            "q": "4. 我們如何使用您的個人資訊",
            "para": "我們使用、存儲和處理您的資訊（包括您的個人資訊），以提供、理解、改進和開發我們的出門問問服務，創建和維護可信賴且更安全的環境並遵守我們的法律義務。",
            "title_4_1": "4.1 提供、改進和開發出門問問的服務",
            "ul_1": {
                "li_1": "向您提供出門問問服務（以及在出門問問服務內的特定/具體功能）。例如，讓您可以在出門問問軟體中進行藍牙呼叫通話，並根據您的位置顯示相關的內容。",
                "li_2": "在您通過線上商店購買我們的產品時，向您提供與服務相關的物流交付、訂單查詢、售後服務以及客戶支持等。",
                "li_3": "在您使用的多個出門問問服務之間共享您的個人資訊。您使用出門問問設備時所收集的個人資訊，可以在另一台出門問問設備中使用，以便為您建議提供特定內容。 您還可以不時地要求我們將您在出門問問服務所存儲的個人資訊轉移或傳送至出門問問的另一服務（如適用）。"
            },
            "para_4_1": "我們處理這些資訊是因為我們對改善出門問問服務的合法義務，並且對於充分履行與您之間的合同而言是必不可少的。",
            "title_4_2": "4.2 創建並維護更加安全的環境",
            "ul_2": {
                "li_1": [
                    "為提供客戶服務、安全、欺詐偵測、存檔和備份，我們提供出門問問服務，根據",
                    "出門問問服務條款",
                    " 其他出門問問政策提供出門問問服務。"
                ],
                "li_2": "履行我們的法律義務。"
            },
            "para_4_2": "我們處理這些資訊，以保護出門問問服務的合法權益，並衡量我們是否充分履行與您簽訂的合同以及遵守適用的法律。",
            "title_4_3": "4.3 提供、定制、衡量和改進我們的廣告和營銷服務",
            "ul_3": {
                "li_1": "為了更好地了解您如何接入和使用出門問問的服務，以便我們改善出門問問的服務，並開發新服務；已經響應用戶的意願和喜好，包括語言設定、位置設定、個性化的支援服務和指示；或者就您和其他出門問問服務的用戶給予其他回應。",
                "li_2": "用於產品展示、個性化推薦和發送促銷營銷資訊，例如飛機/火車旅行行程、電影觀影時間表、局部天氣變化資訊以及感興趣的新聞/主題等。"
            },
            "para_4_3": "我們將出於本節所列出目的處理您的個人資訊，因為我們有合法的興趣從事營銷活動，為您提供您可能感興趣的產品或服務。您可以按照我們的營銷資訊中包含的取消訂閱說明或更改您的出門問問帳戶中的通知設定，可選擇不接收我們的營銷資訊。",
            "title_4_4": "4.4 一般而言，我們僅會將您提供的資訊用於本隱私政策中所述的目的，或者在收集您個人資訊時向您說明的目的。但是，我們也可能將您的個人資訊用於與我們向您透露的目的不相抵觸的其他目的，比如出於重大公共利益、科學或者歷史研究，或統計研究，但前提是相關司法管轄區公佈的適用數據保護法允許；在這種情況下，我們會事前徵得您的同意。",
            "title_4_5": [
                "4.5 如 ",
                "出門問問服務條款",
                "對您的個人資訊作出任何約定, 仍以本隱私政策為准。"
            ]
        },
        "terms_5": {
            "q": "5. 我們如何分享、轉讓、公開披露和保留您的個人資訊",
            "desc": "We do not share personal information with other companies, organizations and individuals unless one of the following circumstances applies:",
            "title_5_1": "5.1 徵得您的同意",
            "para_5_1": "除以下情況外，未經您的肯定同意，我們不會向任何第三方分享或轉讓或披露您的個人資訊。",
            "title_5_2": "5.2 合法處理您的資訊的其他方",
            "ul_2": {
                "li_1": [
                    "將您的個人資訊分享給我們認為必要披露的任何 ",
                    "主管執法機構、監管機構、政府機構、法院或其他第三方，",
                    " 以（i）遵守適用的法律法規；（ii）行使、建立或辯護我們的合法權利；（iii）保護您以及任何其他人士的重大利益；或（iv）在您的權利和自由不超過這些合法權益的情況下追求我們的合法權益。"
                ]
            },
            "title_5_3": "5.3 我們的關聯公司",
            "para_5_3": [
                "為了支持我們提供出門問問服務，我們可能會在關聯公司內共享您的資訊，包括個人資訊。我們僅共享必要的個人資訊，並受到本《隱私政策》中規定的目的的約束。如果關聯公司改變個人資訊的處理目的，他們將再次徵求您的授權和同意。有關我們的關聯公司的更多詳情，",
                "",
                "",
                "請點擊",
                "數據共享對於您和我們之間的合同履行是必要的。"
            ],
            "title_5_4": "5.4 服務提供商",
            "ul_4": {
                "li_1": "為履行與您之間的合同，我們可能會與合作夥伴共享您的某些個人資訊。我們的服務提供商遍布歐洲經濟區（「EEA」）內外。特別是，我們的服務提供商位於歐洲、印度、亞太地區和北美地區。",
                "li_2": [
                    "我們將因如下用途與在全球範圍支持我們業務的服務提供商共享所需的資訊： 1）協助我們為您提供出門問問的服務； 2) 協助我們履行「",
                    "我們如何使用您的個人資訊",
                    "」一節所載的目的; 3）履行我們根據 ",
                    "《出門問問服務條款》",
                    " 或本《隱私政策》的責任和強制執行我們的權利；和/或協助理解和改善我們出門問問的服務； 4）提供技術基礎設施服務、分析我們服務的使用模式、衡量廣告和服務的有效性、支付的便利性或進行學術研究和調查。"
                ],
                "li_3": "例如，在您線上購買我們的產品時，我們必須與物流服務供應商共享您的個人資訊（例如：您的送貨地址）才能安排送貨，或者安排合作夥伴提供服務；代表我們發送電子郵件或推送通知的通信服務提供商。",
                "li_4": "我們僅出於合法、正當、必要、特定和明確的目的分享您的個人資訊，並且只會共享提供服務所必要的個人資訊。這些提供商對您的資訊訪問權限有限，無法代表我們執行這些任務，並且應當僅將其用於披露目的且與本隱私政策一致的目的。"
            },
            "title_5_5": "5.5 廣告和分析服務類的授權合作夥伴。",
            "para_5_5": "除非獲得您的許可/同意，否則我們不會將您的個人身份資訊與提供廣告和分析服務的合作夥伴分享。我們會向這些合作夥伴有關其廣告覆蓋面和有效性的資訊，而不會提供您的個人身份資訊，或者我們將這些資訊進行匯總，以便他們不會識別出您個人。例如，如果廣告客戶同意遵守我們的廣告發佈準則后，我們才可能會告訴廣告客戶其廣告的有關效果如何，或者廣告的受眾群體或受廣告影響的人數以安裝應用的反饋，或向這些合作夥伴提供不可識別個人身份的人口統計資訊（例如 「位於法國的25歲男性，喜歡軟體開發」，以幫助他們了解他們的受眾群體或客戶。",
            "title_5_6": "5.6 轉讓",
            "para_5_6": "如果出門問問遭遇合併、收購、重組、出售資產或破產清算，需出售、轉讓或者共享我們的全部或者部分資產，包括與該與交易或者擬定的交易（比如：盡職調查）相關的您的資訊。在這種情況下，我們將要求持有您的個人資訊的新公司、組織繼續受此《隱私政策》的約束，否則我們將要求該公司、組織重新向您征求授權和同意。",
            "title_5_7": "5.7 匯總數據",
            "para_5_7": "我們還可能共享匯總資訊（我們將用戶組合在一起以便不再識別或引用單個用戶的資訊）和其他匿名資訊，用於法規遵從性、行業和市場分析、人口統計分析、營銷和廣告以及其他業務目的。",
            "title_5_8": "5.8 提醒與第三方處理個人資訊",
            "para_5_8": "如果我們或我們的關聯公司必須與任何第三方共享您的個人資訊，以幫助我們提供和改進我們的出門問問的服務，我們還嚴格限制合作夥伴如何使用和披露我們提供的數據。例如，我們將與該第三方簽署嚴格的保密協議，我們將盡合理努力確保第三方根據我們向該第三方發出的指示使用您的個人資訊，包括我們實施的任何適當的保密和安全措施。我們可能會向這些合作夥伴提供匯總和匿名資訊，或其他非個人身份資訊。"
        },
        "terms_6": {
            "q": "6. 我們如何保護您的個人資訊",
            "title_6_1": "6.1 我們已使用符合行業標準的安全保護措施，以保護我們收集和處理您的個人資訊，防止數據遭到未經授權的訪問、公開披露、使用、修改、損壞或丟失。我們會採取一切合理可行的措施，旨在提供適合處理您的個人資訊風險的安全級別。例如，在您在瀏覽器和「服務」之間交換數據（如信用卡資訊）時，它受SSL加密保護；我們同時對《隱私政策》首頁中出現的網頁提供Https安全瀏覽方式；我們會使用加密技術來確保數據的機密性；我們使用受信賴的保護機制來防止數據遭受惡意攻擊；我們會部署訪問控制機制，以確保只有授權人員才能訪問個人資訊；以及我們會舉辦安全和隱私保護培訓課程，以加強我們的員工對於個人資訊保護重要性的認可。",
            "title_6_2": "6.2  在個人數據洩露的情況下，作為數據控制人的出門問問有法律義務立即（通常在七十二小時內）通知其監管機構，除非該違反行為不可能對該權利和自由造成危險或威脅。",
            "title_6_3": "6.3 我們會採取一切合理可行的措施，確保不收集無關的個人資訊。 我們只會在達成《隱私政策》所述目的所需的期限內保留您的個人資訊，除非需要延長保留期或收到法律的允許。",
            "title_6_4": "6.4 互聯網並非絕對安全的環境，而且出門問問用戶的電子郵件、即時通訊、及與其他出門問問的交流方式並未加密。因此，我們強烈建議您不要通過此類方式發送機密資訊。請使用複雜的密碼以保證您的帳戶安全。",
            "title_6_5": "6.5 互聯網環境並非百分之百安全，我們將盡最大努力確保您發送給我們的任何資訊的安全性。在不幸發生個人資訊安全事件后，我們將會按照法律法規的要求，及時向您告知：安全事件的基本情況和可能的產生影響、我們已採取或將要採取的處置措施、您可自主防範和減少您的風險的建議、和對您的補救措施等。我們將及時將相關情況通過電子郵件、信函，電話和推送通知等方式告知您。難以單獨逐一通知個人資訊的所有者時，我們將採取合理有效的方式發佈公告。 同時，根據監管部門的要求，我們將積極向有關部門報告個人資訊安全事件的發展情況。"
        },
        "terms_7": {
            "q": "7. 您管理個人資訊的權利",
            "para": "如果您是歐洲經濟區和中華人民共和國香港特別行政區的居民，您擁有如下數據保護權利：",
            "title_7_1": "7.1  訪問權",
            "para_7_1": [
                "您有權訪問您的個人資訊，法律法規規定的例外情況除外。如果您想要行使該訪問權限，我們可以通過以下方式自行訪問：",
                "如果您無法通過上述連結訪問這些個人資訊，或者您希望訪問上述連結中未提供的有關您的資訊，您可以發送電子郵件至service.tw@mobvoi.com，我們將在收到請求後的盡快回覆，並且無論如何不會超過一個月。",
                "對於您在使用我們的產品或服務過程中而產生的其他個人資訊，只要我們不需要過多投入，我們會向您提供。如果您想要行使數據訪問權，請發送電子郵件至service.tw@mobvoi.com。"
            ],
            "ul_1": {
                "li_1": [
                    "a) ",
                    "帳戶資訊",
                    " -- 您可以訪問或編輯您的帳戶中的個人數據資訊和付款資訊、更改您的密碼、添加安全資訊或關閉您的帳戶等，您可以通過訪問【出門問問App應用程式→用戶中心】來執行此類操作。"
                ],
                "li_2": [
                    "b) ",
                    "搜尋資訊",
                    " -- 您可以訪問【出門問問App應用程式→用戶中心】來訪問或清除您的搜尋歷史記錄、查看和修改您的興趣以及管理其他數據。"
                ]
            },
            "title_7_2": "7.2 更正您的個人資訊",
            "para_7_2": [
                "當您發現我們在處理關於您的個人資訊時有不准確或不完整的情況，您有權要求我們做出更正。您可以通過訪問【出門問問App應用程式→用戶中心】自行進行更正。",
                "如果您無法通過上述連結更正這些個人資訊，您可以發送電子郵件至service.tw@mobvoi.com提出更正請求。我們將在收到請求後的盡快處理，並且無論如何不會超過一個月。"
            ],
            "title_7_3": [
                "7.3 刪除您的個人資訊"
            ],
            "para_7_3": [
                "在下列情形下，您可以向我們提出刪除您個人資訊的請求：",
                "您可以通過向service.tw@mobvoi.com發送電子郵件來請求刪除您的個人資訊，我們將在收到請求後的盡快回覆，並且無論如何不會超過一個月。",
                "當您從出門問問服務中刪除資訊后，我們可能不會立即從備份系統中刪除相應的資訊，但會在備份更新時刪除這些資訊。"
            ],
            "ul_3": {
                "li_1": "a) 如果我們處理個人資訊的行為違反法律法規；",
                "li_2": "b) 如果我們收集和使用您的個人資訊時，卻未徵得您的同意；",
                "li_3": "c) 如果我們處理個人資訊的行為違反了與您簽訂的約定協議；",
                "li_4": "d) 如果您不再使用我們的產品和服務，或您註銷了您的出門問問帳戶；",
                "li_5": "e) 如果我們不再為您提供出門問問服務。"
            },
            "title_7_4": [
                "7.4 此外，您可以反對我們處理您的個人資訊、要求我們限制處理您的個人資訊或要求複製您的個人資訊。同樣，您可以通過向service.tw@mobvoi.com發送電子郵件來行使這些權利，我們將在收到請求後的盡快回覆，並且無論如何不會超過一個月。",
                "",
                "",
                "",
                "",
                "",
                ""
            ],
            "title_7_5": "7.5 更改您授權和同意的範圍",
            "para_7_5": [
                "每個業務功能都需要一些基本的個人資訊才能得以實現（參見本隱私政策第3節）。除了最低限度的使用/設定之外，您可以在收集和使用您的個人資訊的任何時候給予或撤銷您的授權同意。您可以通過以下方式自行操作【進入個人電話設定→選擇關閉出門問問的服務】。",
                "",
                "",
                "當您撤銷同意后，我們將不再處理相應的個人資訊。但是，您撤銷同意的決定，不會影響基於您之前授權的個人資訊處理，也不會影響您依據合法處理理由而非同意處理您的個人資訊。"
            ],
            "title_7_6": [
                "7.6 我們隨時向您發送營銷資訊的權利",
                ""
            ],
            "para_7_6": [
                "如果您不想接受我們給您發送的商業推廣或營銷資訊，您可以點擊我們發送給您的營銷電子郵件中的「取消訂閱」，並通過「聯繫方式」下提供的聯絡方式與我們聯繫。",
                "",
                ""
            ],
            "title_7_7": "7.7 個人資訊複製權",
            "para_7_7": [
                "您有權獲取您的個人資訊副本。您可以通過以下方式自行操作：向service.tw@mobvoi.com發送電子郵件來，我們將在收到請求後的盡快回覆，並且無論如何不會超過一個月。",
                "如果在技術措施可行的前提下，例如數據接口兼容，我們也可以根據您的要求，直接將您的個人資訊副本傳輸至您指定的第三方。"
            ],
            "title_7_8": "7.8 申訴權",
            "para_7_8": "您有權遵守有關我們收集和使用您的個人資訊的數據保護權限。欲了解有關詳細資訊，請與您當地的數據保護機構取得聯繫。",
            "title_7_9": "7.9 響應您的上述請求",
            "para_7_9": [
                "為了保護安全，您可能需要以書面提供請求，或以其他方式先驗證您的身份後，我們再進行相關處理。對於您的請求，我們將在收到請求後的盡快回覆，並且無論如何不會超過一個月。",
                "對於您的合理的請求，我們原則上不會收取費用。但是，對於多次重複且超出合理限度的請求，我們將視情況而定收取一定的成本費用。對於那些無端重複或者需要過多耗時的技術手段（例如：需要開發新系統或從根本上改變當前的現行慣例）或給其他人的合法權益構成風險或者非常不切實際（例如涉及存儲在備份磁帶/硬盤上的資訊）的請求，我們可能會予以拒絕。"
            ]
        },
        "terms_8": {
            "q": "8. 我們發出的通知",
            "title_8_1": "8.1 通知和其他類型的通訊",
            "para_8_1": "當您使用出門問問服務時，我們可以利用您的個人資訊向您的設備發送電子郵件、短信或推送通知。如果您不希望收到這些簡報，您可以選擇在您的設備上選擇\"「取消通知」\" （如果有）或通過service.tw@mobvoi.com與我們聯繫。",
            "title_8_2": "8.2 與服務有關的公告",
            "para_8_2": "我們可在我們認為必要時（例如，當我們暫停出門問問服務進行維護時）不時向您發送一些與服務相關的公告。您無權取消此類與服務有關、性質不屬於推廣的公告。"
        },
        "terms_9": {
            "q": "9. 在出門問問提供的第三方服務和集成s",
            "para": [
                "出門問問服務可能將您連接至第三方社交媒體或服務，比如第三方集成、聯名服務或者第三方服務 (\"",
                "（以下稱為“第三方合作夥伴”）",
                "\")。出門問問不擁有或控制這些第三方合作夥伴，當您與他們互動時，您可能直接向第三方合作夥伴，出門問問或兩者提供資訊。這些第三方合作夥伴本身擁有關於資訊收集、使用和披露的規則。我們建議您查看您訪問的其他網頁的隱私政策。"
            ],
            "terms_9_1":[
                "",
                ""
            ]
        },
        "terms_10": {
            "q": "10. 數據保留",
            "para": [
                "如果我們有合法的業務需求（例如，提供您所要求的服務或遵守適用的法律、稅務或會計要求），我們將保留從您那裡收集的個人資訊。",
                "如果我們沒有正在進行的合法業務需要處理您的個人資訊，我們將刪除或匿名，或者如無法刪除或做拖敏處理（例如，因為您的個人資訊已存儲在備份檔案中），那麼我們將採取安全措施去存儲您的個人資訊，並將其與任何進一步處理隔離，直到可以刪除。"
            ]
        },
        "terms_11": {
            "q": "11. 全球的業務運營和國際數據轉讓",
            "para": [
                "我們為全球用戶提供服務。如果您所在國家的法律允許，您授權我們在美國、中國大陸和我們經營的任何其他國家轉移、存儲和使用您的個人數據。在我們轉移個人數據的一些國家，有關政府機構何時可以訪問數據的隱私和數據保護法律和規則可能與您所在國家的不同。",
                "具體而言，我們的服務器位於美國，我們的集團公司和第三方服務提供商及合作夥伴遍布全球各地。這意味著，當我們收集您的個人資訊時，我們可能會在這些國家來處理這些資訊。",
                "當我們在歐洲經濟區之外傳輸個人數據時，我們會根據接收國的數據保護法的充分性，對數據接收者的合同義務，確保對數據主體的權利得到適當程度的保護（可能會要求提供示範條款可通過下文所述的詢問方式作出請求），或歐盟-美國和瑞士-美國的隱私保護原則。",
                "現在，我們已採取適當的保護措施，要求您的個人資訊將根據本《隱私政策》繼續受到保護。其中包括實施歐盟委員會關於在集團公司之間轉移個人資訊的標準合同條款，要求所有集團公司根據歐盟數據保護法保護他們從歐洲經濟區處理的個人資訊。",
                "如需獲取我們的標準合同條款，可發送電子郵件至service.tw@mobvoi.com。我們已與第三方服務提供商和合作夥伴實施了類似的適當保護措施，並可根據要求提供更多詳細資訊。"
            ]
        },
        "terms_12": {
            "q": "12. 我們如何使用Cookie和其他追蹤技術",
            "para": [
                "我們可不時使用cookies和類似追蹤技術 (統稱為, \"Cookies\") 收集使用關於您與您有關的個人資訊。有關我們使用的Cookie類型、原因以及如何控制Cookie的詳細資訊，請參閱我們的",
                "Cookie政策。",
                "。"
            ]
        },
        "terms_13": {
            "q": "13. 我們如何處理兒童的個人資訊",
            "title_13_1": "13.1 出門問問的服務主要面向成人。對於歐洲經濟區16歲以下的居民，未經父母或監護人同意，他們不能使用我們的服務。對於年齡在13至16歲之間的歐洲經濟區居民，您是否可以在父母或監護人的合法同意下使用我們的服務取決於您的國內法。",
            "title_13_2": "13.2 對於出門問問針對兒童的產品（例如兒童智慧手錶）或者服務，您應承諾並同意，您是使用該兒童的父母或監護人，您有權代表孩子接受本《隱私政策》，並允許我們根據本《隱私政策》中所規定的目的和方式收集和處理兒童資訊。",
            "title_13_3": "13.3 在作為歐洲經濟區居民中出門問問用戶年齡滿16歲時，其父母和監護人以前的同意無效，他/她有權同意或不同意提供、分享、刪除他/她提供給我們的個人資訊，或選擇註銷他/她的帳戶。",
            "title_13_4": "13.4 如果我們發現自己在未事先獲得可證實的父母同意的情況下收集兒童的個人資訊，我們會毫不遲疑地刪除相關數據。"
        },
        "terms_14": {
            "q": "14. 《隱私政策》的更新",
            "title_14_1": "我們可能會不時更新我們的《隱私政策》。如果我們對本《隱私政策》進行修訂，我們將在網頁上發布修訂後的《隱私政策》，並更新本《隱私政策》頂部的「上次更新」日期。",
            "title_14_2": "14.2 在您選擇繼續使用我們的服務之前，我們將要求您審核修訂後的隱私政策。如果您不同意修訂後的《隱私政策》，您可以註銷帳戶。如果您在修訂後的《隱私政策》生效之前未取消您的帳戶，則您繼續訪問或使用出門問問服務將受修訂後的《隱私政策》的約束。",
            "title_14_3": "14.3 對於重大變更，根據具體情況我們還可能會提供更為顯著的通知說明《隱私政策》的具體變更內容。",
            "title_14_4": "14.4 重大變更包括但不限於：",
            "ul_4": {
                "li_1": "我們的服務模式中發生了重大變化，例如處理個人資訊的目的、處理的個人資訊的類型以及個人資訊的使用方式等；",
                "li_2": "我們在所有權結構和組織架構等方面發生重大變化，例如業務調整或破產或併購等引起的所有者變更等；",
                "li_3": "個人資訊共享，轉移或公開披露的主要對象發生變化；",
                "li_4": "您參與個人資訊處理方面的權利及其行使此類權利的方式發生重大變化；",
                "li_5": "我們負責處理個人資訊安全合理性相關的責任部門或聯絡方式及投訴渠道發生變化時；",
                "li_6": "個人資訊安全影響評估報告中所述的高風險時間。"
            },
            "para_14_4": "如果您需要查看《隱私政策》的歷史版本，請通過發送電子郵件service.tw@mobvoi.com與我們取得聯繫。"
        },
        "terms_15": {
            "q": "15. 聯繫方式",
            "para": "如果您對本隱私政策有任何疑問、意見或建議或希望與我們討論本《隱私政策》或任何有關事宜，請通過{supportEmail}聯繫我們的個人資訊保護專員。可在本隱私政策的序言中找到您的個人資訊的數據控制人。"
        }
    },
}

export default cn
